import { Component, input, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from '@app/core/services/toast.service';
import { TableRowData } from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

@Component({
    selector: 'app-copyable-text-display',
    template: `
        <div class="tw-flex tw-items-center tw-justify-start">
            {{ displayValue }}
            @if (displayValue) {
                <button
                    (click)="onCopyClick()"
                    mat-icon-button
                    [matTooltip]="
                        'OUTGOING-GOODS.NOTIFICATION-VIEW.COPY' | translate
                    "
                    [cdkCopyToClipboard]="displayValue">
                    <mat-icon
                        fontSet="material-symbols-outlined"
                        class="tw-m-0 !tw-mr-0 tw-self-center tw-text-center tw-align-middle"
                        >file_copy</mat-icon
                    >
                </button>
            }
        </div>
    `,
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        ClipboardModule,
        TranslateModule,
    ],
})
export class CopyableTextDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();

    private toastService = inject(ToastService);
    private translateService = inject(TranslateService);

    get displayValue(): string {
        return String(this.value() || '');
    }

    onCopyClick(): void {
        this.toastService.success(
            this.translateService.instant('GENERAL.COPIED-TO-CLIPBOARD')
        );
    }
}
